<form
	name="configure_collection_form"
	class="form"
	[formGroup]="collection_form"
	(submit)="onSubmit()"
	(input)="onFormInput($event)"
	novalidate
>
	<ng-container *ngIf="collection_location_options.length > 1">
		<div class="heading">
			<h4>Choose your preferred collection location...</h4>
		</div>
		<div class="row">
			<div class="col-xxs-30">
				<ui-radio-button-control
					[form]="collection_form"
					[form_control]="collection_form.controls['collection_location_id']"
					[label]="'Preferred Collection Location'"
					[options]="collection_location_options"
					(changed)="onRadioButtonInput()"
				></ui-radio-button-control>
			</div>
		</div>
	</ng-container>
	<div class="heading">
		<h4>Choose your preferred appointment time...</h4>
	</div>
	<div class="row">
		<div class="col-xxs-30">
			<ui-date-picker-control
				[form]="collection_form"
				[form_control]="collection_form.controls['collection_date']"
				[label]="'Preferred Collection Date'"
				[start_date]="collection_date_min"
				[unavailable_days]="unavailable_days"
				[unavailable_dates]="unavailable_dates"
				[min_date]="collection_date_min"
				(changed)="onDatePickerInput()"
			></ui-date-picker-control>
		</div>

		<div class="col-xxs-30">
			<ui-select-control
				[form]="collection_form"
				[form_control]="collection_form.controls['collection_time']"
				[label]="'Preferred Collection Time'"
				[options]="collection_time_options"
				[empty_allowed]="false"
				[placeholder]="'Choose time of day...'"
			></ui-select-control>
		</div>

		<div class="col-xxs-30 submit-button-container">
			<button
				class="button positive-button block-button"
				[class.loading]="submitting"
				data-element-click="button__engage_configure_delivery_options[collection]__positive-button[Submit Collection Request]"
			>
				<span class="loading-spinner"></span>
				<span *ngIf="!submitting">Submit Collection Request</span>
			</button>
		</div>
	</div>
</form>
